import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Keyboard, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/swiper.css';
import 'swiper/css/pagination';

document.addEventListener('alpine:init', () => {
    Alpine.data('initReinsuranceSlider', () => {
        return {
            inView: false,
            swiper: {},
            pictureIndex: 0,
            init () {
                const swiperParams: SwiperOptions = {
                    modules: [Keyboard, Pagination],
                    init: false,
                    // loop: true,
                    centeredSlides: true,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    keyboard: {
                        enabled: true
                    },
                    pagination: {
                        clickable: true,
                        el: this.$refs.pagination,
                        type: 'bullets',
                    }
                };
                const swiper = new Swiper(
                    this.$refs.swiperContainer,
                    swiperParams
                );
                this.swiper = swiper;
                if (window.innerWidth <= 1024) {
                    this.$nextTick(() => {
                        swiper.init();
                    });
                }

            }
        };
    });
});
